import loginPrompt from './loginPrompt';
import tradeOnboarding from './tradeOnboarding';
import mobileAds from './mobileAds';
import abandonCheckout from './abandonCheckout';

export default [
    loginPrompt,
    tradeOnboarding,
    mobileAds,
    ...abandonCheckout
];



// WEBPACK FOOTER //
// ./src/notificationQueue/globalNotifications/index.js